module.exports = __webpack_public_path__ + "img/text.08d650b3.png";